import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react-lite';
import { useQueueStore } from '../context/use-queue-store';
import { Grid } from '@cad-arc';

function BaseStickyGroupHeader(
    { children, style, ...rest }: { style?: CSSProperties; children: React.ReactNode },
    ref: React.ForwardedRef<HTMLDivElement>
): React.ReactElement {
    const store = useQueueStore();

    return (
        <Grid
            position="relative"
            // we have to manually adjust the top distance to account for our sticky column header height
            top="22px"
            {...rest}
            ref={ref}
            style={{
                '--fullColumnWidth': `${store.workspacePanel.queue.queueColumns.reduce(
                    (acc, column) => acc + column.width,
                    0
                )}px`,
                ...style,
            }}
        >
            {children}
        </Grid>
    );
}

export const StickyGroupHeader = observer(React.forwardRef(BaseStickyGroupHeader));
